import React from "react";
import styled from "styled-components";

export default styled.span`
    font-size: 22px;
    color: black;
    display: inline-block;
    position: relative;
    top: -9px;
    left: 10px;
`;